<span *ngIf="item">
  <ion-item button (click)="itemClicked()" [ngStyle]="{'padding-left': (16 * level) + 'px'}" lines="none">
    <ion-label class="ion-text-wrap">
      {{item.name}}
    </ion-label>
    <ion-button slot="end" *ngIf="!item.visualization_type" fill="clear" [disabled]="true" color="light">
      <ion-icon [name]="showLabels ? 'caret-down':'caret-forward'" slot="icon-only"></ion-icon>
    </ion-button>
  </ion-item>

  <span *ngIf="showLabels">

    <app-tree-item (onSelected)="selectLabel($event)" *ngFor="let child of item.children" [level]="level + 1" [item]="child"></app-tree-item>

    <!-- Do not show the labels when the visualization type is present (E.g. When is a series item)-->
    <span *ngIf="!item.visualization_type">
      <app-tree-label (onSelected)="selectLabel($event)" *ngFor="let lbl of item.labels" [label]="lbl" [level]="level + 1"></app-tree-label>
    </span>
  </span>
</span>